import Vue from "vue";
import AuthService from "@/configurations/authentications/auth";
import Router from "vue-router";
import Main from "@/components/main";
import Dashboard from "@/dashboard/index";
import Login from "@/authentications/login";
import Register from "@/authentications/register";
import Roles from "@/roles/role";
import ManageRoles from "@/roles/manageroles";
import updateRole from "@/roles/updaterole";
import roleModules from "@/modules/module";
import manageModules from "@/modules/managemodules";
import newPermission from "@/permissions/permission";
import managePermissions from "@/permissions/managepermissions";
import user from "@/users/user";
import manageusers from "@/users/manageusers";
import updateUser from "@/users/updateuser";
import userRoles from "@/userroles/userrole";
import userProfile from "@/profile/userprofile";
import managecustomers from "@/customers/managecustomers";
import managecustomerfiles from "@/customers/managecustomerfiles";
import customer from "@/customers/customer";
import updatecustomer from "@/customers/updatecustomer";
import manageimporters from "@/importers/manageimporters";
import importer from "@/importers/importer";
import updateimporter from "@/importers/updateimporter";
import manageshippinglines from "@/shippinglines/manageshippinglines";
import shippingline from "@/shippinglines/shippingline";
import updateshippingline from "@/shippinglines/updateshippingline";
import managetransporters from "@/transporters/managetransporters";
import transporter from "@/transporters/transporter";
import updatetransporter from "@/transporters/updatetransporter";
import managefileopenings from "@/fileopenings/managefileopenings";
import fileopening from "@/fileopenings/fileopening";
import updatefileopening from "@/fileopenings/updatefileopening";
import managecargoentries from "@/cargoentries/managecargoentries";
import cargoentry from "@/cargoentries/cargoentry";
import updatecargoentry from "@/cargoentries/updatecargoentry";
import manageshippingdepartments from "@/shippingdepartment/manageshippingdepartments";
import manageshippingdepartment from "@/shippingdepartment/manageshippingdepartment";
import shippingdepartment from "@/shippingdepartment/shippingdepartment";
import updateshippingdepartment from "@/shippingdepartment/updateshippingdepartment";
import managecustomreleases from "@/customreleases/managecustomreleases";
import managecustomrelease from "@/customreleases/managecustomrelease";
import customrelease from "@/customreleases/customrelease";
import updatecustomrelease from "@/customreleases/updatecustomrelease";
import tarrif from "@/tarrifs/tarrif";
import managetarrifs from "@/tarrifs/managetarrifs";
import updatetarrif from "@/tarrifs/updatetarrif";
import managetrucks from "@/trucks/managetrucks";
import trucks from "@/trucks/trucks";
import updatetruck from "@/trucks/updatetruck";
import managecustombonds from "@/bonds/managecustombonds";
import managebonds from "@/bonds/managebonds";
import bond from "@/bonds/bond";
import updatebond from "@/bonds/updatebond";
import managerequisitions from "@/requisitions/managerequisitions";
import requisition from "@/requisitions/requisition";
import managebondtrackings from "@/bondtrackings/managebondtrackings";
import bondtracking from "@/bondtrackings/bondtracking";
import updatebondtracking from "@/bondtrackings/updatebondtracking";
import managetrucktrackings from "@/trucktrackings/managetrucktrackings";
import trucktracking from "@/trucktrackings/trucktracking";
import updatetrucktracking from "@/trucktrackings/updatetrucktracking";
import interchange from "@/interchanges/interchange";
import fileopeneddate from "@/reports/fileopeneddate";
import dailyexpenses from "@/reports/dailyexpenses";
import weeklyexpenses from "@/reports/weeklyexpenses";
import monthlyexpenses from "@/reports/monthlyexpenses";
import cashaccount from "@/reports/cashaccount";
import managepettycashes from "@/pettycashes/managepettycashes";
import pettycash from "@/pettycashes/pettycash";
import managedailytransactions from "@/dailytransactions/managedailytransactions";
import dailytransaction from "@/dailytransactions/dailytransaction";
import manageaccounttypes from "@/accounttypes/manageaccounttypes";
import accounttype from "@/accounttypes/accounttype";
import managepettyaccounts from "@/pettyaccounts/managepettyaccounts";
import pettyaccount from "@/pettyaccounts/pettyaccount";
import invoice from "@/invoices/invoice";
import managefileinvoicing from "@/invoices/managefileinvoicing";
import manageinvoices from "@/invoices/manageinvoices";
Vue.use(Router);
const Auth = new AuthService();

const ifNotAuthenticated = (to, from, next) => {
  if (!Auth.isLoggedIn()) {
    next();
    return;
  }
  next("/");
};

const ifAuthenticated = (to, from, next) => {
  if (Auth.isLoggedIn()) {
    next();
    return;
  }
  next("/login");
};

const router = new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      beforeEnter: ifAuthenticated,
      component: Main,
      children: [
        {
          path: "",
          component: Dashboard
        },
        {
          path: "/dashboard",
          name: "Dashboard",
          component: Dashboard,
          beforeEnter: ifAuthenticated
        }
      ]
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      beforeEnter: ifNotAuthenticated
    },
    {
      path: "/dashboard",
      component: Main,
      children: [
        {
          path: "/role",
          name: "Roles",
          component: Roles
        },
        {
          path: "/managerole",
          name: "manageRoles",
          component: ManageRoles
        },
        {
          path: "/updateRole",
          name: "roleUpdate",
          component: updateRole
        },
        {
          path: "/newmodule",
          name: "newModule",
          component: roleModules
        },
        {
          path: "/managemodules",
          name: "manageModules",
          component: manageModules
        },
        {
          path: "/permission",
          name: "permissions",
          component: newPermission
        },
        {
          path: "/managepermissions",
          name: "managePermissions",
          component: managePermissions
        },
        {
          path: "/newuser",
          name: "user",
          component: user
        },
        {
          path: "/manageusers",
          name: "manageUsers",
          component: manageusers
        },
        {
          path: "/updateuser",
          name: "updateUser",
          component: updateUser
        },
        {
          path: "/userroles",
          name: "userRoles",
          component: userRoles
        },
        {
          path: "/profile",
          name: "profile",
          component: userProfile
        },
        {
          path: "/managecustomers",
          name: "managecustomers",
          component: managecustomers
        },
        {
          path: "/managecustomerfiles",
          name: "managecustomerfiles",
          component: managecustomerfiles
        },
        {
          path: "/newcustomer",
          name: "customer",
          component: customer
        },
        {
          path: "/updatecustomer",
          name: "updatecustomer",
          component: updatecustomer
        },
        {
          path: "/manageimporters",
          name: "manageimporters",
          component: manageimporters
        },
        {
          path: "/newimporter",
          name: "importer",
          component: importer
        },
        {
          path: "/updateimporter",
          name: "updateimporter",
          component: updateimporter
        },
        {
          path: "/manageshippinglines",
          name: "manageshippinglines",
          component: manageshippinglines
        },
        {
          path: "/newshippingline",
          name: "shipping",
          component: shippingline
        },
        {
          path: "/updateshippingline",
          name: "updateshippingline",
          component: updateshippingline
        },
        {
          path: "/managetransporters",
          name: "managetransporters",
          component: managetransporters
        },
        {
          path: "/newtransporter",
          name: "transporter",
          component: transporter
        },
        {
          path: "/updatetransporter",
          name: "updatetransporter",
          component: updatetransporter
        },
        {
          path: "/managefileopenings",
          name: "managefileopenings",
          component: managefileopenings
        },
        {
          path: "/newfile",
          name: "fileopening",
          component: fileopening
        },
        {
          path: "/updatefileopening",
          name: "updatefileopening",
          component: updatefileopening
        },
        {
          path: "/managecargoentries",
          name: "managecargoentries",
          component: managecargoentries
        },
        {
          path: "/newcargoentry",
          name: "cargoentry",
          component: cargoentry
        },
        {
          path: "/updatecargoentry",
          name: "updatecargoentry",
          component: updatecargoentry
        },
        {
          path: "/manageshippingdepartments",
          name: "manageshippingdepartments",
          component: manageshippingdepartments
        },
        {
          path: "/manageshippingdepartment",
          name: "manageshippingdepartment",
          component: manageshippingdepartment
        },
        {
          path: "/newshippingdetail",
          name: "shippingdepartment",
          component: shippingdepartment
        },
        {
          path: "/updateshippingdepartment",
          name: "updateshippingdepartment",
          component: updateshippingdepartment
        },
        {
          path: "/managecustomreleases",
          name: "managecustomreleases",
          component: managecustomreleases
        },
        {
          path: "/managecustomrelease",
          name: "managecustomrelease",
          component: managecustomrelease
        },
        {
          path: "/newcustomrelease",
          name: "customrelease",
          component: customrelease
        },
        {
          path: "/updatecustomrelease",
          name: "updatecustomrelease",
          component: updatecustomrelease
        },
        {
          path: "/managetarrifs",
          name: "managetarrifs",
          component: managetarrifs
        },
        {
          path: "/newtarrif",
          name: "tarrif",
          component: tarrif
        },
        {
          path: "/updatetarrif",
          name: "updatetarrif",
          component: updatetarrif
        },
        {
          path: "/managetrucks",
          name: "managetrucks",
          component: managetrucks
        },
        {
          path: "/newTransportertruck",
          name: "trucks",
          component: trucks
        },
        {
          path: "/updatetruck",
          name: "updatetruck",
          component: updatetruck
        },
        {
          path: "/managecustombonds",
          name: "managecustombonds",
          component: managecustombonds
        },
        {
          path: "/managebonds",
          name: "managebonds",
          component: managebonds
        },
        {
          path: "/newbond",
          name: "bond",
          component: bond
        },
        {
          path: "/updatebond",
          name: "updatebond",
          component: updatebond
        },
        {
          path: "/managerequisitions",
          name: "managerequisitions",
          component: managerequisitions
        },
        {
          path: "/newtruckrequisition",
          name: "requisition",
          component: requisition
        },
        {
          path: "/managebondtrackings",
          name: "bondtrackings",
          component: managebondtrackings
        },
        {
          path: "/newbondtracking",
          name: "bondtracking",
          component: bondtracking
        },
        {
          path: "/updatebondtracking",
          name: "updatebondtracking",
          component: updatebondtracking
        },
        {
          path: "/managetrucktrackings",
          name: "managetrucktrackings",
          component: managetrucktrackings
        },
        {
          path: "/newtrucktracking",
          name: "trucktracking",
          component: trucktracking
        },
        {
          path: "/updatetrucktracking",
          name: "updatetrucktracking",
          component: updatetrucktracking
        },
        {
          path: "/cotainerinterchange",
          name: "interchange",
          component: interchange
        },
        {
          path: "/fileopeneddate",
          name: "fileopeneddate",
          component: fileopeneddate
        },
        {
          path: "/dailyexpenses",
          name: "dailyexpenses",
          component: dailyexpenses
        },
        {
          path: "/weeklyexpenses",
          name: "weeklyexpenses",
          component: weeklyexpenses
        },
        {
          path: "/monthlyexpenses",
          name: "monthlyexpenses",
          component: monthlyexpenses
        },
        {
          path: "/cashaccount",
          name: "cashaccount",
          component: cashaccount
        },
        {
          path: "/managepettycashes",
          name: "managepettycashes",
          component: managepettycashes
        },
        {
          path: "/newpettycash",
          name: "pettycash",
          component: pettycash
        },
        {
          path: "/managedailytransactions",
          name: "managedailytransactions",
          component: managedailytransactions
        },
        {
          path: "/newtransaction",
          name: "dailytransaction",
          component: dailytransaction
        },
        {
          path: "/manageaccounttypes",
          name: "manageaccounttypes",
          component: manageaccounttypes
        },
        {
          path: "/newaccount",
          name: "accounttype",
          component: accounttype
        },
        {
          path: "/managepettyaccounts",
          name: "managepettyaccounts",
          component: managepettyaccounts
        },
        {
          path: "/pettyaccount",
          name: "pettyaccount",
          component: pettyaccount
        },
        {
          path: "/managefileinvoicing",
          name: "managefileinvoicing",
          component: managefileinvoicing
        },
        {
          path: "/newinvoice",
          name: "invoice",
          component: invoice
        },
        {
          path: "/manageinvoices",
          name: "manageinvoices",
          component: manageinvoices
        }
      ]
    }
  ]
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js